import React from "react"
import { Route, Routes } from "react-router-dom"
import _ from "lodash"

import { routesDef } from "./routesDef.js"

export default function RoutesBuilder() {
  const getRouteElements = (routesDef) => {
    return _.map(routesDef, (route, i) => {
      return <Route key={i} path={route.path} element={route.element} />
    })
  }
  function handleRoutes() {
    const routeList = getRouteElements(routesDef)
    return <Routes>{routeList}</Routes>
  }
  return handleRoutes()
}
